import { AnimatePresence, motion } from "framer-motion";
import { MdArrowDownward } from "react-icons/md";

interface ScrollDownButtonProps {
  show: boolean;
  onClick?: () => void;
  className?: string;
}

const ScrollDownButton: React.FC<ScrollDownButtonProps> = ({
  show,
  onClick,
  className = "absolute bottom-3 rounded-full p-1.5 left-1/2 inline-flex justify-center items-center bg-neutral-50 cursor-pointer shadow-[0_4px_4px_0_color-mix(in_srgb,var(--color-secondary-600)_20%,transparent)]",
}) => {
  return (
    <AnimatePresence mode="wait">
      {show && (
        <motion.div
          key="scroll-down-button"
          initial={{ opacity: 0, x: "-50%" }}
          animate={{ opacity: 1, x: "-50%" }}
          exit={{ opacity: 0, x: "-50%" }}
          whileHover={{ scale: 1.2 }}
          className={className}
          onClick={onClick}
        >
          <MdArrowDownward className="size-5 fill-secondary-600" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ScrollDownButton;
